// src/routes/AppRouter.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'; 

// Importa tus componentes existentes
import MainLayout from '../components/layout/MainLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import Login from '../pages/Login/Login';

// Compras
import SolicitudesCompras from '../pages/Compras/SolicitudesCompras';
import OrdenesCompra from '../pages/Compras/OrdenesCompra';
import ImportadorOrdenes from '../pages/Compras/ImportadorOrdenes';
import CentrosCosto from '../pages/Compras/CentrosCosto';
import CentroNotificaciones from '../pages/Notificaciones/CentroNotificaciones'; 

// Artículos
import Articulos from '../pages/Articulos/Articulos';
import ImportadorArticulos from '../pages/Articulos/ImportadorArticulos';
import ActualizadorArticulos from '../pages/Articulos/ActualizadorArticulos';

// Consignación
import Consignacion from '../pages/Consignacion/Consignacion';

// --- NUEVOS INFORMES ---
import AsistenteReclamos from '../pages/Informes/AsistenteReclamos';
import PendienteEntrega from '../pages/Informes/PendienteEntrega';
import StatusAutorizacion from '../pages/Informes/StatusAutorizacion';

import { ProtectedRoute } from './ProtectedRoute'; 

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta de Login (pública) */}
        <Route path="/login" element={<Login />} />

        {/* Rutas Principales (privadas) */}
        {/* ProtectedRoute verifica que el usuario esté logueado */}
        <Route element={<ProtectedRoute />}>
          
          {/* MainLayout incluye el Navbar y el contenedor principal */}
          <Route element={<MainLayout />}>
            
            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />
            
            {/* Rutas de Compras */}
            <Route path="/compras/solicitudes" element={<SolicitudesCompras />} />
            <Route path="/compras/ordenes" element={<OrdenesCompra />} />
            <Route path="/compras/intercompany" element={<ImportadorOrdenes />} />
            <Route path="/compras/centros-costo" element={<CentrosCosto />} />
            <Route path="/notificaciones" element={<CentroNotificaciones />} />

            {/* Consignación */}
            <Route path="/consignacion" element={<Consignacion />} />

            {/* Rutas de Artículos */}
            <Route path="/articulos" element={<Articulos />} />
            <Route path="/articulos/importador" element={<ImportadorArticulos />} />
            <Route path="/articulos/actualizar" element={<ActualizadorArticulos />} />

            {/* --- RUTAS DE INFORMES (NUEVAS) --- */}
            <Route path="/informes/reclamos" element={<AsistenteReclamos />} />
            <Route path="/informes/pendientes" element={<PendienteEntrega />} />
            <Route path="/informes/status" element={<StatusAutorizacion />} />

          </Route>
        </Route>

        {/* Cualquier ruta desconocida redirige al Dashboard */}
        <Route path="/*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};